import "./footer.scss";
//
import React, { useState } from "react";
import classNames from "classnames";
import { ReactComponent as Arrow } from "static/icons/arrow.svg";
import { useStore } from "shell/store/store";

interface footerProps {}

const Footer: React.FC<footerProps> = () => {
  const language = useStore((state) => state.language);
  const year = new Date().getFullYear();
  const [isLangToggle, setLangToggle] = useState<boolean>(false);

  const data: any = require(`data/footer.data.${language}.json`);

  return (
    <div className={classNames("footer", { "is-lang-toggle": isLangToggle })}>
      <div className="wrapper">
        <div className="footer__flex">
          <div className="footer-copyright">
            Copyright&copy;&nbsp;
            {year}
            &nbsp; Samsung. {data.copyright}
          </div>

          <div className="footer__bottom grid-row">
            <div className="footer-language grid-cell">
              {/* LANGUAGE TOGGLE */}
              <div className="footer-language-toggle">
                {data.language.map(
                  (item: { link: string; label: string }, key: number) => (
                    <a href={item.link} key={key}>
                      <span>{item.label}</span>
                      <Arrow />
                    </a>
                  )
                )}
              </div>

              {/* LANGUAGE TOGGLE END */}
              <button
                onClick={() => setLangToggle(!isLangToggle)}
                className="footer-language-click"
              >
                <span>{data.languageCurrent}</span>
                <Arrow />
              </button>
            </div>

            <div className="footer-divider grid-cell">
              <div className="footer-divider__line" />
            </div>

            <div className="footer__bottom-right grid-row">
              <div className="footer-terms grid-cell">
                {data.legal.map(
                  (item: { link: string; label: string }, key: number) => (
                    <a
                      href={item.link}
                      target="_blank"
                      className="footer-terms__link"
                      key={key}
                      rel="noreferrer"
                    >
                      <span>{item.label}</span>
                    </a>
                  )
                )}
              </div>
              <div className="footer-social grid-cell">
                {/* <span className="footer-social__label">
                  {data.social.label}
                </span> */}
                {data.social.icons.map(
                  (item: { link: string; icon: string }, key: number) => (
                    <a
                      href={item.link}
                      target="_blank"
                      className="footer-social__link"
                      key={key}
                      rel="noreferrer"
                    >
                      <img src={process.env.PUBLIC_URL + item.icon} alt="" />
                    </a>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
